// extracted by mini-css-extract-plugin
export default {"text":"text__XQ6DM","textcomp":"textcomp__wtVMZ","container":"container__Grkw7","heading":"heading__V2vEQ","center":"center__qpQWB"};